import apiClient from './api';

export async function loginApi(email: string, password: string) {
  const response = await apiClient.post('users/login', { email, password });
  return response.data;
}
